import { useEffect } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";
import { useSelector, useDispatch } from "react-redux";
import {
  getCompanyDetailsStart,
  saveCompanyDetailsStart,
} from "../../../../../../redux/slices/setting/settingsSlice";

const CompanyInfoModal = ({ editModalOpen, setEditModalOpen }) => {
  const initialFormData = {
    companyName: "",
    email: [],
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
  };
  const { user } = useSelector((state) => state?.auth);
  const { formData, errors, handleChange, setFormData, validateAllFields } =
    useFormHandler(initialFormData, {
      companyName: { type: "text", required: true },
      address1: { type: "text", required: true },
      city: { type: "text", required: true },
      state: { type: "text", required: true },
      country: { type: "text", required: true },
      zipCode: { type: "number", required: true },
    });
  const dispatch = useDispatch();
  const { generalDetails} = useSelector(
    (state) => state.settings.companyProfile,
  );
  console.log(generalDetails)

  useEffect(() => {
    if (editModalOpen) {
      dispatch(
        getCompanyDetailsStart({
          coll: "Organization",
          method: "GET",
          fil: {
            uiid: { type: "NONE", value: user?.data?.organizationId?.uiid },
          },
          url: ENDPOINTS.ORGANIZATIONS.GET,
        }),
      );
    }
  }, [editModalOpen, dispatch, user?.data?.organizationId?.uiid]);

  useEffect(() => {
    if (generalDetails) {
      setFormData({
        companyName: generalDetails?.name || "",
        email: generalDetails?.contactInformation?.[0]?.email || [],
        address1: generalDetails?.address?.address1 || "",
        address2: generalDetails?.address?.address2 || "",
        city: generalDetails?.address?.city || "",
        state: generalDetails?.address?.state || "",
        country: generalDetails?.address?.country || "",
        zipCode: generalDetails?.address?.zipCode || "",
      });
    }
  }, [generalDetails, setFormData]);

  const updateCompanyInfo = () => {
    const payload = {
      id: user?.data?.organizationId?._id,
      payload: {
        $set: {
          name: formData.companyName,
          displayName: formData.companyName,
          address: {
            address1: formData.address1,
            address2: formData.address2,
            city: formData.city,
            state: formData.state,
            country: formData.country,
            zipCode: formData.zipCode,
          },
          email: formData.email,
        },
      },
    };
    dispatch(saveCompanyDetailsStart(payload));
    setEditModalOpen(false);
  };
  const handleSubmit = () => {
    const isValid = validateAllFields();
    if (!isValid) return;
    updateCompanyInfo();
  };

  return (
    <Modal
      title={"Edit Company information"}
      onClose={() => setEditModalOpen(false)}
      isOpen={editModalOpen}
      width="max-w-2xl"
      titleColor={"primary"}
    >
      <div>
        <div className="grid grid-cols-1 mt-4 gap-5">
          <FormFieldSet
            type="text"
            title={"Company Name"}
            placeholder="Enter Company Name"
            shadow={true}
            value={formData.companyName}
            onChange={(val) => handleChange("companyName", val)}
            error={errors.companyName}
            required
          />
          {/* <FormFieldSet
            type="email"
            title={"Email"}
            placeholder="Enter Email"
            shadow={true}
            value={Array.isArray(formData.email) ? formData.email : []}
            onChange={(val) =>
              handleChange("email", Array.isArray(val) ? val : [val])
            }
            error={errors.email}
            required
          /> */}
        </div>

        <div className="grid grid-cols-1 mt-5 gap-5">
          <FormFieldSet
            type="text"
            title={"Address Line 1"}
            placeholder="Enter Address Line 1"
            shadow={true}
            value={formData.address1}
            onChange={(val) => handleChange("address1", val)}
            error={errors.address1}
            required
          />
          <FormFieldSet
            type="text"
            title={"Address Line 2"}
            placeholder="Enter Address Line 2 (Optional)"
            shadow={true}
            value={formData.address2}
            onChange={(val) => handleChange("address2", val)}
          />
        </div>

        <div className="grid grid-cols-2 mt-5 gap-5">
          <FormFieldSet
            type="text"
            title={"City"}
            placeholder="Enter City"
            shadow={true}
            value={formData.city}
            onChange={(val) => handleChange("city", val)}
            error={errors.city}
            required
          />
          <FormFieldSet
            type="text"
            title={"State"}
            placeholder="Enter State"
            shadow={true}
            value={formData.state}
            onChange={(val) => handleChange("state", val)}
            error={errors.state}
            required
          />
          <FormFieldSet
            type="text"
            title={"Country"}
            placeholder="Enter Country"
            shadow={true}
            value={formData.country}
            onChange={(val) => handleChange("country", val)}
            error={errors.country}
            required
          />
          <FormFieldSet
            type="number"
            title={"Zip"}
            placeholder="Enter Zip Code"
            shadow={true}
            value={formData.zipCode}
            onChange={(val) => handleChange("zipCode", val)}
            error={errors.zipCode}
            required
          />
        </div>

        <div className="flex gap-3 justify-end my-8">
          <Button
            title="Cancel"
            variant="outlined"
            color="black"
            onClick={() => {
              (setFormData(initialFormData), setEditModalOpen(false));
            }}
          />
          <Button title="Save" onClick={handleSubmit} />
        </div>
      </div>
    </Modal>
  );
};

export default CompanyInfoModal;
